import React from 'react';

const LogoMobile = () => {
    return (
        <div className="logo-container">
          <div className="mabe"><img src='/images/logo_blanco_mabe.png' alt="Logo Mabe" width="100%" /></div>
          <div className="capacita">Capacita</div>
        </div>
      );
};

export default LogoMobile;